let initialized = false;

export function initializeAnalyticsIfConsented() {
  const measurementId = process.env.REACT_APP_GA_MEASUREMENT_ID;
  if (!measurementId || initialized) {
    return;
  }

  if (document.getElementById('ga-script')) {
    initialized = true;
    return;
  }

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  script.id = 'ga-script';
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;
  gtag('js', new Date());
  gtag('config', measurementId);

  initialized = true;
}
